

import React from 'react';
import { Card, CardContent, Typography, List, ListItem, ListItemText } from '@mui/material';
import TrafficLightIntersection from '../Charts/TrafficLightIntersection';
import OSMMap from '../OSMMap';

const TrafficLightPreview = ({ trafficLightDetails }) => {

  const trafficLightStates = [
    {
      timestamp: "2024-11-16T08:00:00",
      lights: [
        { state: "red", orientation: 0 },
        { state: "green", orientation: 90 },
        { state: "yellow", orientation: 180 },
        { state: "red", orientation: 270 },
      ],
    },
    {
      timestamp: "2024-11-16T08:00:45",
      lights: [
        { state: "green", orientation: 0 },
        { state: "yellow", orientation: 90 },
        { state: "red", orientation: 180 },
        { state: "green", orientation: 270 },
      ],
    },
    {
      timestamp: "2024-11-16T08:01:30",
      lights: [
        { state: "yellow", orientation: 0 },
        { state: "red", orientation: 90 },
        { state: "green", orientation: 180 },
        { state: "yellow", orientation: 270 },
      ],
    },
    {
      timestamp: "2024-11-16T08:02:15",
      lights: [
        { state: "red", orientation: 0 },
        { state: "green", orientation: 90 },
        { state: "yellow", orientation: 180 },
        { state: "red", orientation: 270 },
      ],
    },
    {
      timestamp: "2024-11-16T08:03:00",
      lights: [
        { state: "green", orientation: 0 },
        { state: "red", orientation: 90 },
        { state: "yellow", orientation: 180 },
        { state: "green", orientation: 270 },
      ],
    },
    {
      timestamp: "2024-11-16T08:03:45",
      lights: [
        { state: "yellow", orientation: 0 },
        { state: "yellow", orientation: 90 },
        { state: "red", orientation: 180 },
        { state: "yellow", orientation: 270 },
      ],
    },
    {
      timestamp: "2024-11-16T08:04:30",
      lights: [
        { state: "red", orientation: 0 },
        { state: "yellow", orientation: 90 },
        { state: "green", orientation: 180 },
        { state: "red", orientation: 270 },
      ],
    },
    {
      timestamp: "2024-11-16T08:05:00",
      lights: [
        { state: "red", orientation: 0 },
        { state: "green", orientation: 90 },
        { state: "yellow", orientation: 180 },
        { state: "red", orientation: 270 },
      ],
    },
  ];
  const [lng,lat] = trafficLightDetails['Location'].coordinates;
  
  return (
    <Card>
      <CardContent>
        <Typography variant="h5" gutterBottom>
          Traffic Light Details
        </Typography>
        <OSMMap lat={lat} lng={lng}></OSMMap>
        <List>
          <ListItem>
            <ListItemText primary="Traffic Light ID" secondary={trafficLightDetails['ATD Location ID'] || 'N/A'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Location Name" secondary={trafficLightDetails['Primary St'] || 'N/A'} />
          </ListItem>
          {/* <ListItem>
            <ListItemText primary="Coordinates" secondary={`${trafficLightDetails.coordinates[1]}, ${trafficLightDetails.coordinates[0]}`} />
          </ListItem> */}
        </List>
        <TrafficLightIntersection trafficLightStates={trafficLightStates} />
    
      </CardContent>
    </Card>
  );
};

export default TrafficLightPreview;
